import { Color, Text } from 'zens-storybook'
import React from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  label: {
    height: 20,
    width: 18,
    marginHorizontal: -6,
  },
  text: {
    textAlign: 'center',
    overflow: 'visible',
    color: Color.metalGrey,
  },
})

interface Props extends ViewProps {}
const Times = (props: Props) => {
  const { style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      {new Array(25).fill('').map((_, index) => {
        const textStyle = [styles.label]
        return (
          <View style={textStyle} key={`time-${index}`}>
            <Text style={styles.text} level={7} numberOfLines={1}>
              {index % 24}
            </Text>
          </View>
        )
      })}
    </View>
  )
}

export default Times
